import React from 'react';
import {
    FormControl,
    Select,
    MenuItem,
    SelectChangeEvent,
} from '@mui/material';
import { styled } from '@mui/material/styles';
import { MonthNumber } from 'routes/HumanResourcesModule/PayState/helpers/types';
import {
    getExerciceMonths,
    getLocalizedMonth,
} from 'routes/HumanResourcesModule/PayState/helpers/dataHelpers';
import { t } from 'i18next';

const StySelect = styled(Select, { name: 'StySelect' })(({ theme }) => ({
    color: theme.palette.primary.main,
    borderRadius: '22px',
    height: '2rem',
    '& .MuiSvgIcon-root': {
        color: theme.palette.primary.main,
    },
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: `${theme.palette.primary.main} !important`,
    },
}));

type Props = {
    allYearOption?: boolean;
    exercice: number;
    selectedMonth: MonthNumber;
    setSelectedMonth: (value: MonthNumber) => void;
};

const MonthSelector = ({
    allYearOption = false,
    exercice,
    selectedMonth,
    setSelectedMonth,
}: Props): React.ReactElement => {
    const exerciceMonths = getExerciceMonths(exercice);
    return (
        <FormControl fullWidth>
            <StySelect
                value={selectedMonth}
                onChange={(event: SelectChangeEvent<MonthNumber>) => {
                    // SelectChangeEvent target value can be string or MonthNumber
                    // we want ensure that this is not a string to keep correct typing
                    if (typeof event.target.value !== 'string')
                        setSelectedMonth(event.target.value);
                }}
            >
                {allYearOption && (
                    <MenuItem value={0}>
                        <>{t('humanResources.payState.allYearOption')}</>
                    </MenuItem>
                )}
                {exerciceMonths.map((month) => (
                    <MenuItem value={month} key={month}>
                        {getLocalizedMonth(month)}
                    </MenuItem>
                ))}
            </StySelect>
        </FormControl>
    );
};

export default MonthSelector;
